var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    !_vm.canContinue
      ? _c(
          "div",
          [
            _c(
              "custom-callout",
              { attrs: { "border-color": "orange", "has-toggle": false } },
              [
                _c(
                  "div",
                  { staticClass: "py-2" },
                  [
                    _c(
                      "div",
                      { staticClass: "d-flex" },
                      [
                        _c("icon-view", {
                          staticClass: "mt-5 mb-3 mt-md-0 mt-sm-5",
                          attrs: {
                            gradient: false,
                            icon: "far fa-file-invoice p-2",
                            "icon-background": "#ff7058",
                            "icon-color": "white",
                            "icon-size": "14px",
                            title: "Añadir Solicitud de PSF"
                          }
                        })
                      ],
                      1
                    ),
                    _c("validation-observer", { ref: "formObserver" }, [
                      _c("div", { staticClass: "row p-2" }, [
                        _c(
                          "div",
                          { staticClass: "col-md-3" },
                          [
                            _c("validation-provider", {
                              attrs: { rules: "required" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function({ errors }) {
                                      return [
                                        _c("custom-drop-down", {
                                          staticClass: "w-100",
                                          attrs: {
                                            "custom-error-msg":
                                              "El área es requerida.",
                                            error: errors[0],
                                            fieldkey: "id",
                                            fieldname: "name",
                                            label: "Área:",
                                            options: _vm.collections.areas,
                                            placeholder: "Seleccione"
                                          },
                                          on: { input: _vm.onAreaChange },
                                          model: {
                                            value: _vm.model.area,
                                            callback: function($$v) {
                                              _vm.$set(_vm.model, "area", $$v)
                                            },
                                            expression: "model.area"
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                2121019208
                              )
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "col-md-3" },
                          [
                            _c("validation-provider", {
                              attrs: { rules: "required" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function({ errors }) {
                                      return [
                                        _c("custom-drop-down", {
                                          staticClass: "w-100",
                                          attrs: {
                                            "custom-error-msg":
                                              "El servicio es requerida.",
                                            error: errors[0],
                                            fieldkey: "id",
                                            fieldname: "name",
                                            label: "Servicio a Ofrecer:",
                                            options: _vm.services,
                                            placeholder: "Seleccione"
                                          },
                                          model: {
                                            value: _vm.model.service,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.model,
                                                "service",
                                                $$v
                                              )
                                            },
                                            expression: "model.service"
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                3848683301
                              )
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "col-md-3" },
                          [
                            _c("validation-provider", {
                              attrs: { rules: "required" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function({ errors }) {
                                      return [
                                        _c("custom-drop-down", {
                                          staticClass: "w-100",
                                          attrs: {
                                            "custom-error-msg":
                                              "El tipo de contratación es requerido.",
                                            error: errors[0],
                                            fieldkey: "id",
                                            fieldname: "name",
                                            label: "Tipo de Contratación:",
                                            options:
                                              _vm.collections.contractTypes,
                                            placeholder: "Seleccione"
                                          },
                                          model: {
                                            value: _vm.model.contractType,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.model,
                                                "contractType",
                                                $$v
                                              )
                                            },
                                            expression: "model.contractType"
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                3984994731
                              )
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "col-md-3" },
                          [
                            _c("validation-provider", {
                              attrs: { rules: "required" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function({ errors }) {
                                      return [
                                        _c("custom-input", {
                                          attrs: {
                                            "custom-error-msg":
                                              "El campo es requerido",
                                            error: errors[0],
                                            label: "Nombre:",
                                            maxlength: "100",
                                            placeholder: "Escriba el nombre"
                                          },
                                          model: {
                                            value: _vm.model.name,
                                            callback: function($$v) {
                                              _vm.$set(_vm.model, "name", $$v)
                                            },
                                            expression: "model.name"
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                1021350980
                              )
                            })
                          ],
                          1
                        )
                      ]),
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-end mt-3" },
                        [
                          _c("action-button", {
                            attrs: {
                              i: "fas fa-times-circle",
                              text: "Cancelar",
                              variant: "outline-danger mr-3 pl-3 pr-4"
                            },
                            on: { click: _vm.onCancelHandler }
                          }),
                          _c("action-button", {
                            attrs: {
                              i: "fas fa-arrow-circle-right",
                              text: "Continuar",
                              variant: "success pl-3 pr-3"
                            },
                            on: { click: _vm.onSaveHandler }
                          })
                        ],
                        1
                      )
                    ])
                  ],
                  1
                )
              ]
            )
          ],
          1
        )
      : _c(
          "div",
          {},
          [
            _c("section-title", {
              attrs: {
                content: "Contratación de Servicios Profesionales",
                icon: "fas fa-bell",
                reverse: ""
              }
            }),
            _vm._m(0),
            _c(
              "validation-observer",
              { ref: "formObserverPart2" },
              [
                _c("section-title", {
                  attrs: {
                    content:
                      "Certificación de Ausencia de Conflicto de Interes",
                    icon: "fas fa-bell",
                    reverse: ""
                  }
                }),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-auto" }, [_vm._v("Yo,")]),
                  _c(
                    "div",
                    { staticClass: "col-md-3" },
                    [
                      _c("validation-provider", {
                        attrs: { rules: "required" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _c("custom-input", {
                                  attrs: {
                                    id: "representativeName",
                                    "custom-error-msg": "El campo es requerido",
                                    error: errors[0]
                                  },
                                  model: {
                                    value: _vm.model.representativeName,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.model,
                                        "representativeName",
                                        $$v
                                      )
                                    },
                                    expression: "model.representativeName"
                                  }
                                })
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  ),
                  _c("div", { staticClass: "col-md-auto" }, [
                    _vm._v(" en mi carácter personal y en representación de ")
                  ]),
                  _c(
                    "div",
                    { staticClass: "col-md-3" },
                    [
                      _c("validation-provider", {
                        attrs: { rules: "required" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _c("custom-input", {
                                  attrs: {
                                    id: "representativeBusiness",
                                    "custom-error-msg": "El campo es requerido",
                                    error: errors[0]
                                  },
                                  model: {
                                    value: _vm.model.representativeBusiness,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.model,
                                        "representativeBusiness",
                                        $$v
                                      )
                                    },
                                    expression: "model.representativeBusiness"
                                  }
                                })
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  ),
                  _c("div", { staticClass: "col-md-auto" }, [
                    _vm._v(
                      " (nombre de la compañía, corporación, sociedad o individuo), "
                    )
                  ])
                ]),
                _c("div", { staticClass: "row mt-3 mb-5" }, [
                  _c("div", { staticClass: "col-md-auto" }, [
                    _vm._v("mayor de edad,")
                  ]),
                  _c(
                    "div",
                    { staticClass: "col-md-2" },
                    [
                      _c("validation-provider", {
                        attrs: { rules: "required" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _c("custom-input", {
                                  attrs: {
                                    id: "representativeMaritalStatus",
                                    "custom-error-msg": "El campo es requerido",
                                    error: errors[0]
                                  },
                                  model: {
                                    value:
                                      _vm.model.representativeMaritalStatus,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.model,
                                        "representativeMaritalStatus",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "model.representativeMaritalStatus"
                                  }
                                })
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  ),
                  _c("div", { staticClass: "col-md-auto" }, [
                    _vm._v(" (estado civil), ")
                  ]),
                  _c(
                    "div",
                    { staticClass: "col-md-2" },
                    [
                      _c("validation-provider", {
                        attrs: { rules: "required" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _c("custom-input", {
                                  attrs: {
                                    id: "representativePosition",
                                    "custom-error-msg": "El campo es requerido",
                                    error: errors[0]
                                  },
                                  model: {
                                    value: _vm.model.representativePosition,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.model,
                                        "representativePosition",
                                        $$v
                                      )
                                    },
                                    expression: "model.representativePosition"
                                  }
                                })
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  ),
                  _c("div", { staticClass: "col-md-auto" }, [
                    _vm._v(
                      " (cargo o puesto que ocupa en la entidad) y vecino de "
                    )
                  ]),
                  _c(
                    "div",
                    { staticClass: "col-md" },
                    [
                      _c("validation-provider", {
                        attrs: { rules: "required" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _c("custom-input", {
                                  attrs: {
                                    id: "representativeAddress",
                                    "custom-error-msg": "El campo es requerido",
                                    error: errors[0]
                                  },
                                  model: {
                                    value: _vm.model.representativeAddress,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.model,
                                        "representativeAddress",
                                        $$v
                                      )
                                    },
                                    expression: "model.representativeAddress"
                                  }
                                })
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  ),
                  _c("div", { staticClass: "col-md-auto" }, [
                    _vm._v(" , (domicilio). ")
                  ])
                ]),
                _c("span", { staticClass: "text-bold" }, [
                  _vm._v(" Certifico lo siguiente: "),
                  _c("br")
                ]),
                _c("span", { staticClass: "text-normal" }, [
                  _c("ol", [
                    _c("li", [
                      _vm._v(
                        " Ningún servidor público de esta agencia ejecutiva tiene interés pecuniario en este contrato, compra o transacción comercial, y tampoco ha tenido en los últimos cuatro (4) años directa o indirectamente interés pecuniario en este negocio. "
                      )
                    ]),
                    _c("li", [
                      _vm._v(
                        " Ningún servidor público de esta agencia ejecutiva me solicitó o aceptó, directa o indirectamente, para él, para algún miembro de su unidad familiar4 o para cualquier persona, regalos, gratificaciones, favores, servicios, donativos, préstamos o cualquier otra cosa de valor monetario. "
                      )
                    ]),
                    _c("li", [
                      _vm._v(
                        " Ningún servidor público me solicitó o aceptó bien alguno de valor económico, vinculados a esta transacción, de persona alguna de mi entidad como pago por realizar los deberes responsabilidades de su empleo. "
                      )
                    ]),
                    _c("li", [
                      _vm._v(
                        " Ningún servidor público me solicitó, directa o indirectamente, para él, para algún miembro de su unidad familiar, ni para cualquier otra persona, negocio o entidad, bien alguno de valor económico, incluyendo regalos, préstamos, promesas, favores o servicios a cambio de que la actuación de dicho servidor público esté influenciada a favor mío o de mi entidad. "
                      )
                    ]),
                    _c("li", [
                      _vm._v(
                        " No tengo relación de parentesco, dentro del cuarto grado de consanguinidad y segundo por afinidad, con ningún servidor público que tenga facultad para influenciar y participar en las decisiones institucionales de esta agencia ejecutiva. "
                      )
                    ]),
                    _c("li", [
                      _vm._v(
                        " No represento intereses particulares en casos o asuntos que impliquen conflicto de intereses, o de política pública, entre la agencia ejecutiva y los intereses particulares que represento. "
                      )
                    ])
                  ])
                ]),
                _c("validation-provider", {
                  attrs: { name: "certificaction", rules: "required" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function({ errors }) {
                        return [
                          _c("custom-checkbox-single-option", {
                            ref: "customCheckboxRef",
                            staticClass:
                              "custom-single-option amendment-document__checkbox",
                            attrs: {
                              "custom-error-msg":
                                "Debe aceptar los Términos y Condiciones para continuar con la creación de la solicitud.",
                              error: errors[0],
                              "option-text": _vm.item.question,
                              title: _vm.item.questionTitle
                            },
                            model: {
                              value: _vm.certified,
                              callback: function($$v) {
                                _vm.certified = $$v
                              },
                              expression: "certified"
                            }
                          })
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "d-flex justify-content-end mt-3" },
              [
                _c("action-button", {
                  attrs: {
                    i: "fas fa-times-circle",
                    text: "Cancelar",
                    variant: "outline-danger mr-3 pl-3 pr-4"
                  },
                  on: { click: _vm.onCancelHandler }
                }),
                _c("action-button", {
                  attrs: {
                    i: "fas fa-arrow-circle-right",
                    text: "Continuar",
                    variant: "success pl-3 pr-3"
                  },
                  on: { click: _vm.onSaveHandler }
                })
              ],
              1
            )
          ],
          1
        )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticStyle: { width: "100%", height: "100%" } }, [
      _c(
        "span",
        {
          staticStyle: {
            color: "black",
            "font-size": "14px",
            "font-family": "Lato",
            "font-weight": "400",
            "line-height": "16.80px",
            "word-wrap": "break-word"
          }
        },
        [
          _vm._v(
            " Según dispuesto en la reglamentación federal, en lo que concierne a la adquisición de servicios bajo asignaciones de fondos federales, los estados se rigen bajo los procesos y políticas que utilizan para fondos no federales "
          )
        ]
      ),
      _c(
        "span",
        {
          staticStyle: {
            color: "black",
            "font-size": "14px",
            "font-family": "Lato",
            "font-weight": "700",
            "line-height": "16.80px",
            "word-wrap": "break-word"
          }
        },
        [
          _vm._v(
            " (sección 200.317 del Título 2 del Código de Reglamentación Federal (2 CFR 200.317)). "
          )
        ]
      ),
      _c(
        "span",
        {
          staticStyle: {
            color: "black",
            "font-size": "14px",
            "font-family": "Lato",
            "font-weight": "400",
            "line-height": "16.80px",
            "word-wrap": "break-word"
          }
        },
        [_vm._v(" Asimismo, la sección ")]
      ),
      _c(
        "span",
        {
          staticStyle: {
            color: "black",
            "font-size": "14px",
            "font-family": "Lato",
            "font-weight": "700",
            "line-height": "16.80px",
            "word-wrap": "break-word"
          }
        },
        [_vm._v(" 200.459 ")]
      ),
      _c(
        "span",
        {
          staticStyle: {
            color: "black",
            "font-size": "14px",
            "font-family": "Lato",
            "font-weight": "400",
            "line-height": "16.80px",
            "word-wrap": "break-word"
          }
        },
        [_vm._v(" del Título 2 del Código de Reglamentación Federal ")]
      ),
      _c(
        "span",
        {
          staticStyle: {
            color: "black",
            "font-size": "14px",
            "font-family": "Lato",
            "font-weight": "700",
            "line-height": "16.80px",
            "word-wrap": "break-word"
          }
        },
        [_vm._v(" (2 CFR 200.459) ")]
      ),
      _c(
        "span",
        {
          staticStyle: {
            color: "black",
            "font-size": "14px",
            "font-family": "Lato",
            "font-weight": "400",
            "line-height": "16.80px",
            "word-wrap": "break-word"
          }
        },
        [
          _vm._v(
            " , bajo los principios de costos, define en términos amplios los servicios profesionales y de consultoría como aquellos servicios prestados por personas que son miembros de una profesión en particular o poseen una habilidad especial, y que no son funcionarios empleados de la entidad no federal, en este caso, el DEPR. "
          ),
          _c("br"),
          _c("br"),
          _vm._v(" La ")
        ]
      ),
      _c(
        "span",
        {
          staticStyle: {
            color: "black",
            "font-size": "14px",
            "font-family": "Lato",
            "font-weight": "700",
            "line-height": "16.80px",
            "word-wrap": "break-word"
          }
        },
        [_vm._v(" Ley núm. 237 de 2004 ")]
      ),
      _c(
        "span",
        {
          staticStyle: {
            color: "black",
            "font-size": "14px",
            "font-family": "Lato",
            "font-weight": "400",
            "line-height": "16.80px",
            "word-wrap": "break-word"
          }
        },
        [_vm._v(" , según enmendada, ")]
      ),
      _c(
        "span",
        {
          staticStyle: {
            color: "black",
            "font-size": "14px",
            "font-family": "Lato",
            "font-weight": "700",
            "line-height": "16.80px",
            "word-wrap": "break-word"
          }
        },
        [
          _vm._v(
            " “Ley para establecer parámetros uniformes en los procesos de contratación de servicios profesionales o consultivos para las agencias y entidades gubernamentales del Estado Libre Asociado de Puerto Rico, y para otros fines” "
          )
        ]
      ),
      _c(
        "span",
        {
          staticStyle: {
            color: "black",
            "font-size": "14px",
            "font-family": "Lato",
            "font-weight": "400",
            "line-height": "16.80px",
            "word-wrap": "break-word"
          }
        },
        [
          _vm._v(
            " dispone sobre los asuntos relacionados con la contratación de servicios profesionales o consultivos. Sin embargo, no establece un procedimiento o mecanismo en particular que deba utilizarse para seleccionar la persona natural o jurídica con quien se van a contratar los servicios profesionales o consultivos. No obstante, el DEPR, mediante esta guía, ha establecido procesos de adquisición directa, cuando aplique, o competencia para la selección de servicios profesionales y/o consultivos de forma tal que resulten en la mejor oferta para esta agencia. "
          ),
          _c("br"),
          _c("br"),
          _vm._v(
            " Todo proceso para la adquisición de servicios profesionales y/o consultivos en este proceso se originará mediante una "
          )
        ]
      ),
      _c(
        "span",
        {
          staticStyle: {
            color: "black",
            "font-size": "14px",
            "font-family": "Lato",
            "font-weight": "700",
            "line-height": "16.80px",
            "word-wrap": "break-word"
          }
        },
        [_vm._v(" solicitud (PSF 1 (a) o PSF 1 (b)) ")]
      ),
      _c(
        "span",
        {
          staticStyle: {
            color: "black",
            "font-size": "14px",
            "font-family": "Lato",
            "font-weight": "400",
            "line-height": "16.80px",
            "word-wrap": "break-word"
          }
        },
        [_vm._v(" para la revisión y aprobación de la ")]
      ),
      _c(
        "span",
        {
          staticStyle: {
            color: "black",
            "font-size": "14px",
            "font-family": "Lato",
            "font-weight": "700",
            "line-height": "16.80px",
            "word-wrap": "break-word"
          }
        },
        [_vm._v(" Unidad de Adjudicación de Fondos (UAF). ")]
      ),
      _c(
        "span",
        {
          staticStyle: {
            color: "black",
            "font-size": "14px",
            "font-family": "Lato",
            "font-weight": "400",
            "line-height": "16.80px",
            "word-wrap": "break-word"
          }
        },
        [
          _vm._v(
            " Esta debe contener una descripción del servicio que se peticiona, una justificación sobre la necesidad, vigencia, requisitos relacionados, estimado de costo, fuente de financiamiento y cualquier otro documento necesario para la evaluación adecuada del servicio. En el caso de enmiendas y renovaciones, también debe indicar qué contrato se solicita para enmendar o renovar. "
          ),
          _c("br"),
          _c("br")
        ]
      ),
      _c("span", { staticClass: "text-bold" }, [
        _vm._v(
          " Para la evaluación de los servicios profesionales la UAF, además, deberá considerar los siguientes elementos: "
        ),
        _c("br")
      ]),
      _c("span", { staticClass: "text-normal" }, [
        _c("ol", [
          _c("li", [
            _vm._v(
              " El servicio es permisible y en beneficio del programa federal que los sufragará. "
            )
          ]),
          _c("li", [
            _vm._v(
              " Se justifican las actividades, tareas o servicios que se proponen realizar. "
            )
          ]),
          _c("li", [
            _vm._v(
              " Si existe un impacto en los servicios de un programa federal o no federal distinto del indicado en la solicitud de servicio. Si de la evaluación surge que los servicios impactan más de un programa, la Unidad Contratante deberá identificar los fondos correspondientes con cargos en proporción al impacto de los servicios en los programas. "
            )
          ]),
          _c("li", [
            _vm._v(
              " Los servicios a solicitar no deben formar parte de los costos indirectos reclamados o a reclamar por el DEPR. "
            )
          ]),
          _c("li", [
            _vm._v(
              " Los servicios que solicitarán tienen el propósito de complementar y no reemplazar o sustituir actividades que deban ser sufragadas con fondos estatales, locales o de otros programas federales; excepto que por disposición de una ley federal se indique lo contrario. "
            )
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }